import { useQuery } from '@tanstack/react-query'
import { getLogs } from '../api/logs'
import { queryKeys } from '../lib/query-client'

/**
 * Hook to fetch logs for a run.
 *
 * @param fileId - The run's file ID
 * @param enabled - Whether to fetch (disable for SSE streaming)
 * @returns Query result with logs array
 */
export function useLogs(fileId: string | undefined, enabled = true) {
  return useQuery({
    queryKey: queryKeys.logs.detail(fileId || ''),
    queryFn: () => getLogs(fileId!),
    enabled: !!fileId && enabled,
    staleTime: 1000 * 60, // 1 minute - logs don't change after run completes
  })
}
